//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  queryKey: ['subscribers'],
  queryOptions: {},
  type: "blog",
  search: "",
};

const getAllSubscribers = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: subscribers, total },
  } = await axios.get(`/api/subscribers?${queryString}`);
  return {subscribers, total};
};

export const useSubscribers = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, companyType, type, search } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    offset: page * limit,
    type: type,
    search: search,
  };

  return useQuery([...queryKey, companyType, type, page, limit, search], () => getAllSubscribers(queryStringParams), {
    select: ({ subscribers, total }) => ({ subscribers, total }),
    initialData: {
      subscribers: [],
      total: 0,
    },
    ...queryOptions,
  });
};
